import { ActiveMember, MemberKind } from '../types/members-types';
import { snapshot } from 'valtio';
import InviteMemberStore from '../stores/invite-user-store';
import MembersStore from '../stores/members-store';
import { isValidEmail } from 'common-utils';
import {
  ScopeConfig,
  parseScopesString,
} from '@oxappsec/ox-unified-permissions/src/scopes';

export const reduceRelatedMembersIDs = (activeMembers: ActiveMember[]) => {
  return Object.values(
    activeMembers.reduce(
      (acc: Record<string, ActiveMember>, cur: ActiveMember) => {
        const am: ActiveMember = { ...cur };
        am.relatedIDs = [];
        const found = acc[am.email];
        if (found) {
          found.relatedIDs = [...found.relatedIDs, am.user_id];
        } else {
          acc[am.email] = { ...am, kind: MemberKind.ActiveMember };
        }
        return acc;
      },
      {},
    ),
  );
};

export const isAlreadyInvited = (email: string) => {
  const { pendingInvitationMembers } = snapshot(InviteMemberStore);
  return pendingInvitationMembers.some(p => p.inviteeEmail === email);
};

export const isAlreadyAMember = (email: string) => {
  const { activeMembers } = snapshot(MembersStore);
  return activeMembers.some(a => a.email === email);
};

export const getInvalidEmailsObj = (emails: string[]) => {
  const defaultObject = { invalidEmails: [], invalidEmailsErrMsg: '' };
  if (emails.length === 0) {
    return defaultObject;
  }
  const invalidEmails = emails.filter(email => !isValidEmail(email));
  if (invalidEmails.length === 0) {
    return defaultObject;
  }
  return {
    invalidEmails,
    invalidEmailsErrMsg: `Invalid emails: ${invalidEmails.join(', ')}.`,
  };
};

export const getAlreadyInvitedOrMemberEmailsObj = (emails: string[]) => {
  const defaultObject = {
    alreadyInvitedOrMemberEmails: [],
    alreadyInvitedOrMemberEmailsErrMsg: '',
  };
  if (emails.length === 0) {
    return defaultObject;
  }
  const alreadyInvitedOrMemberEmails = emails.filter(email => {
    if (isAlreadyAMember(email) || isAlreadyInvited(email)) {
      return true;
    }
    return false;
  });
  if (alreadyInvitedOrMemberEmails.length === 0) {
    return defaultObject;
  }
  return {
    alreadyInvitedOrMemberEmails,
    alreadyInvitedOrMemberEmailsErrMsg: `Emails already invited: ${alreadyInvitedOrMemberEmails.join(
      ', ',
    )}.`,
  };
};

export const getScopeItems = (scopes: string) => {
  const parsedScopes = scopes && parseScopesString(scopes);
  if (parsedScopes) {
    return parsedScopes.reduce((acc: ScopeConfig[], cur) => {
      const item = { ...cur };
      cur.values = cur?.values?.filter(item => !!item);
      acc.push(item);
      return acc;
    }, []);
  }
};
